import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import {
  GetAllUserOfSingleClientListPayloadType,
  UnassignedUserOfSingleClient,
} from "../../commonTypes/authTypes";
import {
  AadhaarAndPanUniqueCheckPayloadType,
  GetSingleClientDirectoryPayloadType,
  UpdateClientDirectoryPayloadType,
} from "../../commonTypes/clientDirectoryTypes";
import ClientDirectoryForm from "../../components/ClientDirectory/ClientDirectoryForm";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../components/commons";
import {
  getAllAssignUserOfSingleClientAction,
  resetAllAssignUserOfSingleClient,
  resetAuthSuccess,
  resetSession,
  unassignedUserOfSingleClient,
} from "../../redux/auth";
import { GetAllAssignUserOfSingleClient } from "../../redux/auth/authTypes";
import {
  clientAadharUniqueCheckAction,
  clientPanUniqueCheckAction,
  getSingleClientDirectoryAction,
  resetClientAadharUniqueCheckError,
  resetClientAadharUniqueCheckMessage,
  resetClientAadharUniqueCheckSuccess,
  resetClientDirectoryError,
  resetClientDirectoryList,
  resetClientDirectoryMessage,
  resetClientDirectoryStatusCode,
  resetClientDirectorySuccess,
  resetClientPanUniqueCheckError,
  resetClientPanUniqueCheckMessage,
  resetClientPanUniqueCheckSuccess,
  resetSingleClientDirectory,
  updateClientDirectoryAction,
} from "../../redux/clientDirectory";
import { RootState } from "../../redux/rootReducers";
import { resetGstDetails } from "../../redux/services";
import { UserIcon } from "../../components/Icon";
type AppProps = {
  history: any;
  token: string | null;
  message: string | null;
  clientAadharUniqueCheckMessage: string | null;
  clientPanUniqueCheckMessage: string | null;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  fetching: boolean;
  isState: null | boolean;
  isCity: null | boolean;
  singleClientDirectory: any;
  clientAadharUniqueCheckFetching: boolean;
  clientAadharUniqueCheckError: string | null;
  clientAadharUniqueCheckSuccess: number | null;
  clientPanUniqueCheckFetching: boolean;
  userFetching: boolean;
  clientPanUniqueCheckError: string | null;
  clientPanUniqueCheckSuccess: number | null;
  allAssignUserOfSingleClient: GetAllAssignUserOfSingleClient;
  dispatchResetClientDirectorySuccess: () => void;
  dispatchResetClientDirectoryError: () => void;
  dispatchResetClientDirectoryMessage: () => void;
  dispatchResetClientDirectoryStatusCode: () => void;
  dispatchResetSingleClientDirectory: () => void;
  dispatchResetSession: () => void;
  dispatchResetClientDirectoryList: () => void;
  dispatchResetClientAadharUniqueCheckSuccess: () => void;
  dispatchResetClientAadharUniqueCheckError: () => void;
  dispatchResetClientAadharUniqueCheckMessage: () => void;
  dispatchClientAadharUniqueCheckAction: (
    data: AadhaarAndPanUniqueCheckPayloadType
  ) => void;
  dispatchResetClientPanUniqueCheckSuccess: () => void;
  dispatchResetClientPanUniqueCheckError: () => void;
  dispatchResetClientPanUniqueCheckMessage: () => void;
  dispatchResetAllAssignUserOfSingleClient: () => void;
  dispatchResetGstDetails: () => void;
  dispatchClientPanUniqueCheckAction: (
    data: AadhaarAndPanUniqueCheckPayloadType
  ) => void;
  dispatchUpdateClientDirectory: (
    data: UpdateClientDirectoryPayloadType
  ) => void;
  dispatchGetSingleClientDirectoryAction: (
    data: GetSingleClientDirectoryPayloadType
  ) => void;
  dispatchGetAllAssignUserOfSingleClientAction: (
    data: GetAllUserOfSingleClientListPayloadType
  ) => void;
  dispatchUnassignedUserOfSingleClient: (
    data: UnassignedUserOfSingleClient
  ) => void;
  authSuccess: number | null;
  dispatchResetAuthSuccess: () => void;
};
const EditClient = ({
  history,
  token,
  statusCode,
  success,
  fetching,
  userFetching,
  error,
  isState,
  isCity,
  allAssignUserOfSingleClient,
  dispatchResetClientDirectorySuccess,
  dispatchResetClientDirectoryError,
  dispatchResetClientDirectoryMessage,
  dispatchResetClientDirectoryStatusCode,
  dispatchResetSession,
  dispatchUpdateClientDirectory,
  dispatchGetSingleClientDirectoryAction,
  dispatchResetSingleClientDirectory,
  dispatchResetClientDirectoryList,
  singleClientDirectory,
  dispatchClientAadharUniqueCheckAction,
  dispatchResetClientAadharUniqueCheckSuccess,
  dispatchResetClientAadharUniqueCheckError,
  dispatchResetClientAadharUniqueCheckMessage,
  dispatchClientPanUniqueCheckAction,
  dispatchResetClientPanUniqueCheckSuccess,
  dispatchResetClientPanUniqueCheckError,
  dispatchResetClientPanUniqueCheckMessage,
  clientAadharUniqueCheckFetching,
  clientPanUniqueCheckFetching,
  clientAadharUniqueCheckMessage,
  clientPanUniqueCheckMessage,
  dispatchGetAllAssignUserOfSingleClientAction,
  dispatchResetAllAssignUserOfSingleClient,
  dispatchResetGstDetails,
  dispatchUnassignedUserOfSingleClient,
  authSuccess,
  dispatchResetAuthSuccess,
}: AppProps) => {
  const clientCode = history?.location?.state?.clientCode;
  const sortByCc = history?.location?.state?.sortByCc;
  const sortByName = history?.location?.state?.sortByName;
  const sortByCf = history?.location?.state?.sortByCf;
  const searchValue = history?.location?.state?.searchValue;
  const persistCategory = history?.location?.state?.selectedClientCategoryFilter
    ? history?.location?.state?.selectedClientCategoryFilter
    : [];
  const persistcategoryFilter = history?.location?.state?.clientCategoryFilter
    ? history?.location?.state?.clientCategoryFilter
    : [];
  const persistScope = history?.location?.state?.selectedScopeofWorkFilter
    ? history?.location?.state?.selectedScopeofWorkFilter
    : [];
  const persistScopeFilter = history?.location?.state?.scopeofWorkFilter
    ? history?.location?.state?.scopeofWorkFilter
    : [];
  const persistBranchFilter = history?.location?.state?.branchFilter
  const persistContactTypeFilter = history?.location?.state?.contactTypeFilter;
  const persistSignUpSourceFilter = history?.location?.state?.signUpSourceFilter;
  
  useEffect(() => {
    dispatchResetClientDirectorySuccess();
    dispatchResetClientDirectoryError();
    dispatchResetClientDirectoryMessage();
    dispatchResetClientDirectoryStatusCode();
    dispatchResetSingleClientDirectory();
    dispatchResetClientAadharUniqueCheckSuccess();
    dispatchResetClientAadharUniqueCheckError();
    dispatchResetClientAadharUniqueCheckMessage();
    dispatchResetClientPanUniqueCheckSuccess();
    dispatchResetClientPanUniqueCheckError();
    dispatchResetClientPanUniqueCheckMessage();
    dispatchResetAllAssignUserOfSingleClient();
    dispatchResetGstDetails();
    dispatchResetClientDirectoryList();
    dispatchResetAuthSuccess();
  }, []);

  useEffect(() => {
    if (clientCode && token) {
      const finalData = {
        token,
        clientCode,
      };
      dispatchGetSingleClientDirectoryAction(finalData);
      const data = {
        token,
        client_code: clientCode,
      };
      dispatchGetAllAssignUserOfSingleClientAction(data);
    }
  }, [clientCode]);

  const handleClientPanUniqueCheck = (data: any) => {
    if (token) {
      const finalData = {
        token,
        clientCode: singleClientDirectory?.code,
        ...data,
      };
      dispatchClientPanUniqueCheckAction(finalData);
    }
  };

  const handleAssignedUsersFilter = (data: any) => {
    if (token) {
      const finalData = {
        token,
        client_code: clientCode,
        search_term: data?.searchValue,
        user_type: data?.userType ? +data?.userType : "",
      };
      dispatchGetAllAssignUserOfSingleClientAction(finalData);
    }
  };

  const handleClientAadharUniqueCheck = (data: any) => {
    if (token) {
      const finalData = {
        token,
        clientCode: singleClientDirectory?.code,
        ...data,
      };
      dispatchClientAadharUniqueCheckAction(finalData);
    }
  };

  const handleSubmit = (data: any) => {
    if (token) {
      const finalData = {
        token,
        status: singleClientDirectory?.status,
        clientCode: singleClientDirectory?.code,
        comment_count: singleClientDirectory?.lead_info_details?.comment_count,
        lastComment: singleClientDirectory?.lead_info_details?.last_comment,
        migrateToFinac:
          singleClientDirectory?.lead_info_details?.finac_migration_status,
        ...data,
      };
      dispatchUpdateClientDirectory(finalData);
    }
  };

  const handleUnassignUser = (data: any) => {
    if (token) {
      const finalData = {
        token,
        clientId: clientCode,
        userId: data,
      };
      dispatchUnassignedUserOfSingleClient(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetClientDirectoryError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`Client Updated Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetClientDirectoryList();
            dispatchResetClientDirectorySuccess();
            history?.push({
              pathname: "/client-directory-list",
              state: {
                sortByCc,
                sortByCf,
                sortByName,
                searchValue,
                persistCategory,
                persistcategoryFilter,
                persistScope,
                persistScopeFilter,
                persistBranchFilter,
                persistContactTypeFilter,
                persistSignUpSourceFilter,
              },
            });
          }}
          statusCode={statusCode}
        />
      );
    }
    if (authSuccess === 1) {
      dispatchResetAuthSuccess();
    }
  };

  return (
    <>
      <div className="col-md-4 mb-3">
        <CommonHeader title="Edit Client" />
        <div className="d-flex align-items-center ml-3">
          {singleClientDirectory?.user_details?.basic_details?.name ? (
            <>
              <UserIcon /> &nbsp;
              {!!singleClientDirectory?.user_details?.basic_details?.name
                ? singleClientDirectory?.user_details?.basic_details?.name
                : ""}{" "}
              {"(" + singleClientDirectory?.code + ")"}
            </>
          ) : null}
        </div>
      </div>
      <ClientDirectoryForm
        allAssignUserOfSingleClient={
          allAssignUserOfSingleClient ? allAssignUserOfSingleClient : null
        }
        handleAssignedUsersFilter={handleAssignedUsersFilter}
        userFetching={userFetching}
        clientAadharUniqueCheckFetching={clientAadharUniqueCheckFetching}
        clientPanUniqueCheckFetching={clientPanUniqueCheckFetching}
        clientAadharUniqueCheckMessage={clientAadharUniqueCheckMessage}
        clientPanUniqueCheckMessage={clientPanUniqueCheckMessage}
        dispatchResetClientAadharUniqueCheckMessage={
          dispatchResetClientAadharUniqueCheckMessage
        }
        dispatchResetClientPanUniqueCheckMessage={
          dispatchResetClientPanUniqueCheckMessage
        }
        history={history}
        handleSubmit={handleSubmit}
        handleClientPanUniqueCheck={handleClientPanUniqueCheck}
        handleClientAadharUniqueCheck={handleClientAadharUniqueCheck}
        singleClientDirectory={singleClientDirectory}
        isCity={isCity}
        isState={isState}
        handleUnassignUser={handleUnassignUser}
        authSuccess={authSuccess}
      />
      <Toaster />
      {handleErrorModal()}
      {fetching && <Loader />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.clientDirectory.success,
  fetching: state.clientDirectory.fetching,
  message: state.clientDirectory.message,
  statusCode: state.clientDirectory.statusCode,
  error: state.clientDirectory.error,
  singleClientDirectory: state.clientDirectory.singleClientDirectory,
  clientAadharUniqueCheckFetching:
    state.clientDirectory.clientAadharUniqueCheckFetching,
  clientAadharUniqueCheckError:
    state.clientDirectory.clientAadharUniqueCheckError,
  clientAadharUniqueCheckSuccess:
    state.clientDirectory.clientAadharUniqueCheckSuccess,
  clientAadharUniqueCheckMessage:
    state.clientDirectory.clientAadharUniqueCheckMessage,
  clientPanUniqueCheckFetching:
    state.clientDirectory.clientPanUniqueCheckFetching,
  clientPanUniqueCheckError: state.clientDirectory.clientPanUniqueCheckError,
  clientPanUniqueCheckSuccess:
    state.clientDirectory.clientPanUniqueCheckSuccess,
  clientPanUniqueCheckMessage:
    state.clientDirectory.clientPanUniqueCheckMessage,
  allAssignUserOfSingleClient: state.auth.allAssignUserOfSingleClient,
  userFetching: state.auth.fetching,
  isState: state.masterData.isState,
  isCity: state.masterData.isCity,
  authSuccess: state.auth.success,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetClientDirectorySuccess: () =>
    dispatch(resetClientDirectorySuccess()),
  dispatchResetClientDirectoryError: () =>
    dispatch(resetClientDirectoryError()),
  dispatchResetClientDirectoryMessage: () =>
    dispatch(resetClientDirectoryMessage()),
  dispatchResetClientDirectoryStatusCode: () =>
    dispatch(resetClientDirectoryStatusCode()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSingleClientDirectory: () =>
    dispatch(resetSingleClientDirectory()),
  dispatchResetClientDirectoryList: () => dispatch(resetClientDirectoryList()),
  dispatchUpdateClientDirectory: (data: UpdateClientDirectoryPayloadType) =>
    dispatch(updateClientDirectoryAction(data)),
  dispatchGetSingleClientDirectoryAction: (
    data: GetSingleClientDirectoryPayloadType
  ) => dispatch(getSingleClientDirectoryAction(data)),
  dispatchClientAadharUniqueCheckAction: (
    data: AadhaarAndPanUniqueCheckPayloadType
  ) => dispatch(clientAadharUniqueCheckAction(data)),
  dispatchClientPanUniqueCheckAction: (
    data: AadhaarAndPanUniqueCheckPayloadType
  ) => dispatch(clientPanUniqueCheckAction(data)),
  dispatchGetAllAssignUserOfSingleClientAction: (
    data: GetAllUserOfSingleClientListPayloadType
  ) => dispatch(getAllAssignUserOfSingleClientAction(data)),
  dispatchResetClientAadharUniqueCheckSuccess: () =>
    dispatch(resetClientAadharUniqueCheckSuccess()),
  dispatchResetClientAadharUniqueCheckError: () =>
    dispatch(resetClientAadharUniqueCheckError()),
  dispatchResetClientAadharUniqueCheckMessage: () =>
    dispatch(resetClientAadharUniqueCheckMessage()),
  dispatchResetClientPanUniqueCheckSuccess: () =>
    dispatch(resetClientPanUniqueCheckSuccess()),
  dispatchResetClientPanUniqueCheckError: () =>
    dispatch(resetClientPanUniqueCheckError()),
  dispatchResetClientPanUniqueCheckMessage: () =>
    dispatch(resetClientPanUniqueCheckMessage()),
  dispatchResetAllAssignUserOfSingleClient: () =>
    dispatch(resetAllAssignUserOfSingleClient()),
  dispatchResetGstDetails: () => dispatch(resetGstDetails()),
  dispatchUnassignedUserOfSingleClient: (data: UnassignedUserOfSingleClient) =>
    dispatch(unassignedUserOfSingleClient(data)),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditClient);
